import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PermissaoEditarComponent } from './permissao-editar.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: ':id', component: PermissaoEditarComponent }
    ])],
    exports: [RouterModule]
})
export class PermissaoEditarRoutingModule { }
